// Прелоадер отключен - сразу устанавливаем src и вызываем onReady
export const useVideoReady = (
	videoId: string,
	onReady: () => void,
	videoRef?: Ref<HTMLVideoElement | null>
) => {
	// const preloaderStore = usePreloaderStore()

	const applyVideoSrc = () => {
		// Устанавливаем src напрямую из data-src атрибута
		if (videoRef?.value) {
			const video = videoRef.value
			const isMobile = window.innerWidth <= 992
			const mobileSrc = video.dataset.srcMobile
			const desktopSrc = video.dataset.src
			const src = isMobile && mobileSrc ? mobileSrc : desktopSrc
			
			if (src && !video.src) {
				video.src = src
			}
		}
	}

	onMounted(() => {
		// Сразу устанавливаем src и вызываем onReady
		nextTick(() => {
			applyVideoSrc()
			onReady()
		})
	})

	/*
	// Старая логика с прелоадером:
	const checkVideoReady = () => {
		if (preloaderStore.isVideoLoaded(videoId)) {
			applyVideoSrc()
			onReady()
			return true
		}
		return false
	}

	onMounted(() => {
		// Проверяем сразу, может видео уже загружено
		if (checkVideoReady()) {
			return
		}

		// Если нет, следим за изменениями
		const unwatch = watch(
			() => preloaderStore.videoStates[videoId],
			(isLoaded) => {
				if (isLoaded) {
					nextTick(() => {
						applyVideoSrc()
						onReady()
						unwatch()
					})
				}
			}
		)

		onUnmounted(() => {
			unwatch()
		})
	})
	*/
}

